import { useEntityDestroy } from "gen/endpoints/entity/entity";
import { useTranslation } from "react-i18next";
import { useConfirmationDialog } from "shared/components/modal/confirm/ConfirmationDialog";
import { DeleteConfirmationDialog } from "shared/components/modal/DeleteConfirmationDialog";

export const useEntityConfirmDelete = (title?: string) => {
  const { t } = useTranslation(["entity"]);
  const { mutateAsync: deleteEntity } = useEntityDestroy();
  return useConfirmationDialog(
    DeleteConfirmationDialog as DeleteConfirmationDialog<string>,
    {
      title: title ?? t("entity:delete.title"),
      description: t("entity:delete.description"),
      successMessage: t("entity:delete.success"),
      performDelete: (entityId) => deleteEntity({ id: entityId }),
    },
  );
};
